// import React from 'react';
// import './Navbar.css'
// // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// // import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Navbar = ({ toggleSidebar }) => {
//   return (
//     <nav className="navbar navbar-expand-lg navbar-light bg-dark mb-4 mt-2  d-flex justify-content-between custom-navbar">
//       <h4>CorpWings Billing Software</h4>
//     </nav>
//   );
// };

// export default Navbar;


import React from 'react';
import './Navbar.css'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = ({ toggleSidebar }) => {
  return (
    // <nav className="navbar navbar-expand-lg navbar-light mb-4 mt-2  d-flex  custom-navbar">
    //   <h4>CORPWINGS</h4>
    // </nav>
    <><h2 className='billTitle'>
    Invoice Page
    </h2></>
  );
};

export default Navbar;
